import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type InPageAction =
  | 'billingHistory'
  | 'changePaymentMethod'
  | 'cancelSubscription'
  | 'reactivateSubscription'
  | null;

interface ManageSubscriptionStore {
  inPageAction: InPageAction;
  setInPageAction: (action: InPageAction) => void;
}

export const useManageSubscriptionStore = create(
  persist<ManageSubscriptionStore>(
    (set) => ({
      inPageAction: null,
      setInPageAction: (action) => set({ inPageAction: action }),
    }),
    {
      name: 'manage-subscription-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
